import classNames from "classnames";
import React from "react";

export default function ({ className }) {
  return (
    <div
      className={classNames("linksblock block-view", {
        [className]: !!className,
      })}
    >
      <ul className="linksblock__list">
        <li className="linksblock-item">
          <h3 className="linksblock-item__title">Submitter Telegram Handle:</h3>
          <p className="linksblock-item__text">John Doe</p>
        </li>
        <li className="linksblock-item">
          <h3 className="linksblock-item__title">Repo Link:</h3>
          <p className="linksblock-item__text">www.github.com/</p>
        </li>
      </ul>
    </div>
  );
}
